export const extractDesignationLabels = (permissionsState = {}) => {
  const rawDesignations = permissionsState?.permissions?.designations || [];
  console.warn("Raw Designations:", rawDesignations);
  if (!Array.isArray(rawDesignations)) return [];

  return rawDesignations
    .map((item) => {
      if (typeof item === "string" || typeof item === "number") {
        return String(item).trim();
      }
      if (typeof item === "object" && item) {
        return String(
          item.title || item.name || item.label || item.value || item.key || ""
        ).trim();
      }
      return "";
    })
    .filter((value) => value);
};
